(()=>{
  const KEY='EasyGamesCommerceRulesContractV1';
  const SOURCE='easygames-badge-engine-v6 [data-eg-badge-config]';
  const CONTRACT='script[data-eg-commerce-rules-v1]';
  const EVENT='easygames:commerce-contract-change';
  const norm=(value)=>String(value??'').normalize('NFD').replace(/[\u0300-\u036f]/g,'').trim().toLowerCase();
  const num=(value,fallback)=>{const parsed=Number(value);return Number.isFinite(parsed)?parsed:fallback;};
  const asBool=(value)=>value===true||String(value)==='true';
  const parseTags=(value)=>{
    if(value instanceof Set)return new Set([...value].map(norm).filter(Boolean));
    if(Array.isArray(value))return new Set(value.map(norm).filter(Boolean));
    try{const parsed=JSON.parse(String(value||'[]'));if(Array.isArray(parsed))return new Set(parsed.map(norm).filter(Boolean));}catch(_){}
    return new Set(String(value||'').split(',').map(norm).filter(Boolean));
  };

  window[KEY]?.destroy?.();

  const runtime={onSectionLoad:null,destroy:null,
    source(){return document.querySelector(SOURCE);},
    read(){const node=this.source();if(!node)return null;try{return JSON.parse(node.textContent||'{}');}catch(_){return null;}},
    project(config){
      const core=config?.core||{};
      const reserve=core.reserve||{};
      const special=core.special||{};
      const sold=core.sold||{};
      return{
        version:1,
        source:'EG Badges productos',
        mode:'active-contract',
        precedence:['reserve','special','sold','digital','low','in_stock'],
        rules:{
          reserve:{tags:String(reserve.tags||'preordenes'),requireContinue:reserve.requireContinue!==false,inventoryMode:String(reserve.inventoryMode||'any')},
          special:{requireTracked:special.requireTracked!==false,inventoryAtMost:num(special.inventoryAtMost,0),requireContinue:special.requireContinue!==false},
          sold:{inventoryBelow:num(sold.inventoryBelow,1),hideIfContinue:sold.hideIfContinue!==false,untrackedMode:String(sold.untrackedMode||'availability')}
        }
      };
    },
    contract(){const node=document.querySelector(CONTRACT);if(!node)return null;try{return JSON.parse(node.textContent||'{}');}catch(_){return null;}},
    publish(){
      const source=this.source();
      const config=this.read();
      if(!source||!config)return null;
      const contract=this.project(config);
      let node=document.querySelector(CONTRACT);
      if(!node){node=document.createElement('script');node.type='application/json';node.setAttribute('data-eg-commerce-rules-v1','');source.after(node);}
      node.dataset.egContractVersion='1';
      node.dataset.egContractSource='eg-badges-productos';
      node.dataset.egContractMode='active';
      node.textContent=JSON.stringify(contract);
      document.documentElement.dataset.egCommerceContract='v1-active';
      document.dispatchEvent(new CustomEvent(EVENT,{detail:{contract}}));
      return contract;
    },
    normalizeMeta(meta){return{tags:parseTags(meta?.tags),inventory:num(meta?.inventory,0),tracked:asBool(meta?.tracked),continueSelling:asBool(meta?.continueSelling),available:asBool(meta?.available)};},
    reserveMatches(meta,rule){const tags=String(rule?.tags||'preordenes').split(',').map(norm).filter(Boolean);const requireContinue=rule?.requireContinue!==false;const inventoryMode=String(rule?.inventoryMode||'any');const inventoryOk=inventoryMode==='any'||(inventoryMode==='positive'&&meta.tracked&&meta.inventory>0)||(inventoryMode==='zero_or_less'&&meta.tracked&&meta.inventory<=0);return tags.some((tag)=>meta.tags.has(tag))&&(!requireContinue||meta.continueSelling)&&inventoryOk;},
    specialMatches(meta,rule){const trackedOk=rule?.requireTracked===false||meta.tracked;const inventoryOk=!meta.tracked||meta.inventory<=num(rule?.inventoryAtMost,0);const continueOk=rule?.requireContinue===false||meta.continueSelling;return trackedOk&&inventoryOk&&continueOk;},
    soldMatches(meta,rule){if(meta.tracked)return(rule?.hideIfContinue===false||!meta.continueSelling)&&meta.inventory<num(rule?.inventoryBelow,1);return String(rule?.untrackedMode||'availability')==='availability'&&!meta.available;},
    digitalSpecialAllowed(meta,digital){if(!digital?.preventSpecialAuto)return true;const overrideTags=String(digital.specialOverrideTags||'import').split(',').map(norm).filter(Boolean);return overrideTags.some((tag)=>meta.tags.has(tag));},
    classify(meta,context={}){
      const normalized=this.normalizeMeta(meta);
      const contract=this.contract()||this.publish();
      const rules=contract?.rules||{};
      const digital=context.digitalConfig||null;
      const lowThreshold=Math.max(1,num(context.lowThreshold,5));
      const isDigital=normalized.tags.has('digital')&&digital?.enabled!==false;
      if(this.reserveMatches(normalized,rules.reserve))return'reserve';
      if(this.specialMatches(normalized,rules.special)&&(!isDigital||this.digitalSpecialAllowed(normalized,digital)))return'special';
      if(this.soldMatches(normalized,rules.sold))return'sold';
      if(isDigital)return'digital';
      if(normalized.tracked&&normalized.inventory>0&&normalized.inventory<=lowThreshold)return'low';
      return'in_stock';
    }
  };

  runtime.onSectionLoad=()=>requestAnimationFrame(()=>runtime.publish());
  runtime.destroy=()=>document.removeEventListener('shopify:section:load',runtime.onSectionLoad);
  window[KEY]=runtime;
  document.addEventListener('shopify:section:load',runtime.onSectionLoad);
  const start=()=>runtime.publish();
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',start,{once:true});else start();
})();
